export const visit = (vm, at) => {
vm(require("pricing-pages-ui/lang/es.lyaml"));
vm(require("foundations-components/lang/es.lyaml"));
vm(require("feature-monetization/lang/es.lyaml"));
vm(require("usage-based-billing-components-lib/lang/CreditEstimator/es.lyaml"));
vm(require("usage-based-billing-components-lib/lang/es.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/header/es.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/marketing-hub/es.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card/es.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-copy/es.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-price/es.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-term/es.lyaml"));
at({ "es": { "ui": { "UILoadingSpinner": { "busyText": "Cargando", "completedText": "Cargada" } }, "publicPricingPage": { "windowTitles": { "default": "Precios | HubSpot" } } } });
};